"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Mobiledoc_1 = require("../../../types/Mobiledoc");
var AtomRenderer_1 = require("./AtomRenderer");
exports.default = (function (_a) {
    var createElement = _a.createElement, getAtomComponent = _a.getAtomComponent;
    return function (_a) {
        var atoms = _a.atoms;
        return function (_a) {
            var _b;
            var typeIdentifier = _a[0], value = _a[3];
            return ((_b = {},
                _b[Mobiledoc_1.MarkerTypeIdentifier.TEXT] = function (text) { return text; },
                _b[Mobiledoc_1.MarkerTypeIdentifier.ATOM] = function (index) {
                    return AtomRenderer_1.default({ createElement: createElement, getAtomComponent: getAtomComponent })(atoms[index]);
                },
                _b)[typeIdentifier](value));
        };
    };
});
